import Section from "./components/Section";

const App = () => {
  return (
    <div className="App">
      <Section/>
    </div>
  );
}

export default App;
